const INITIAL_STATE = {
    // todoList is what needs to be past to the different pages that need to access it
    todoList: [],
    // todoId: 1,
    currentTodo: null,
    currentTodoName: "Todo Name",
    currentPomodoroNumber: 0,
    todoFinished: 0,
    pomodoroFinished: 0,
    pomodoroTime: 25,
    shortRestTime: 5,
    longRestTime: 15,
    currentDate: new Date(),
    endTime: null,
    todoNote: "",
    todoTemplate: {
        "800am": "Eat and water",
        "830am": "Turn stuff on",
        "900am": "Plan work",
        "930am": "Small important stuff",
        "1000am": "Code",
        "1030am": "Code",
        "1100am": "Code",
        "1130am": "Code",
        "1200pm": "Check food",
        "1230pm": "Dishes",
        "100pm": "Get food",
        "130pm": "Eat",
        "200pm": "Workout",
        "230pm": "Outside",
        "300pm": "Code",
        "330pm": "Code",
        "400pm": "Nap",
        "430pm": "Nap",
        "500pm": "Code",
        "530pm": "Code",
        "600pm": "Eat",
        "630pm": "Dishes",
        "700pm": "Game",
        "730pm": "Game",
        "800pm": "Code",
        "830pm": "Cardio",
        "900pm": "Shower",
        "930pm": "Game",
        "1000pm": "Teeth",
        "1030pm": "Ready for bed",
        "1100pm": "Sleep",
        "1130pm": "Sleep",
        "1200am": "Sleep",
        "1230am": "Sleep",
    }
}

const todos = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // case "INCREASE_TODO_ID":
        //   return {
        //     ...state,
        //     todoId: state.todoId + 1,
        //   }
        // case "SET_TODO_ID":
        //   return {
        //     ...state,
        //     todoId: action.id,
        //   }
        case "INCREASE_TODO_COUNT":
            return {
                ...state,
                todoFinished: state.todoFinished + 1,
            }
        case "SET_POMODORO_NUMBER":
            return {
                ...state,
                currentPomodoroNumber: action.number,
            }
        case "SET_TIMER":
            switch (action.timerType) {
                case "short":
                    return {
                        ...state,
                        shortRestTime: action.minutes,
                    }
                case "long":
                    return {
                        ...state,
                        longRestTime: action.minutes,
                    }
                default:
                    return {
                        ...state,
                        pomodoroTime: action.minutes,
                    }
            }

        case "SET_CURRENT_DATE":
            return {
                ...state,
                currentDate: new Date(),
            }
        case "SET_END_TIME":
            return {
                ...state,
                endTime: action.time,
            }
        case "SET_TODO_NOTE":

            return {
                ...state,
                todoNote: action.noteText,
            }

        case "UPDATE_TEMPLATE":
            debugger
            var updatedTemplate = state.todoTemplate
            updatedTemplate[action.key] = action.value

            localStorage.setItem("todoTemplate", JSON.stringify(updatedTemplate))

            return {
                ...state,
                todoTemplate: updatedTemplate,
            }
            
            
        // For adding a new todo
        case "ADD_TODO":
            // add the todo to the todoList
            // then update the todoList in the state
            var updatedTodoList = [...state.todoList, todo(undefined, action)]
            localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

            return {
                ...state,
                todoList: updatedTodoList,
            }
        case "DELETE_TODO":
            var updatedTodoList = state.todoList.filter(todo => {
                return todo.id !== action.id
            })
            localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

            return {
                ...state,
                todoList: updatedTodoList,
            }
        case "UPDATE_TODO":
            var updatedTodo = todo(undefined, action)
            var updatedTodoList = state.todoList.map(todo => {
                return todo.id === action.id ? updatedTodo : todo
            })
            localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

            return {
                ...state,
                todoList: updatedTodoList,
            }
        case "UPDATE_ALL_TODOS":
            // this need to return the state, which has the todoList
            var updatedTodoList = action.todos
            localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

            return {
                ...state,
                todoList: updatedTodoList,
            }
        case "COMPLETE_TODO":
            return {
                ...state,
                // this is equivalent to setState()
                todoList: state.todoList.map(todo => {
                    if (todo.id === action.id) {
                        updatedTodo = todo
                        updatedTodo.completed = !updatedTodo.completed
                        updatedTodo.isTodoRunning = false
                        updatedTodo.startTime = action.startTime
                        updatedTodo.completionTime = action.completionTime
                        updatedTodo.plannedMinutes = action.plannedMinutes
                        updatedTodo.timeLeft = action.timeLeft
                        updatedTodo.notes = action.notes
                        return updatedTodo
                    }

                    return todo
                }),
            }
        case "TOGGLE_TODO":
            return { ...state, todoList: state.todoList.map(t => todo(t, action)) }
        default:
            return state
    }
}

const buildTodo = ({
    id = Date.now(),
    name,
    notes,
    completed = false,
    isTodoRunning = false,
    plannedMinutes = null,
    timeLeft = plannedMinutes ?? null,
    creationTime = new Date(),
    startTime = null,
    completionTime = null,
    todoType = null,
}) => ({
    id,
    name,
    notes,
    completed,
    isTodoRunning,
    plannedMinutes,
    timeLeft,
    creationTime,
    startTime,
    completionTime,
    todoType,
})

const todo = (state, action) => {
    switch (action.type) {
        case "ADD_TODO":
            return buildTodo(action.todo)

        case "UPDATE_TODO":
            return buildTodo(action.updatedTodo)

        case "TOGGLE_TODO":
            if (state.id !== action.id) return state
            return {
                ...state,
                completed: !state.completed,
            }

        default:
            return state
    }
}

// const todo = (state, action) => {
//   switch (action.type) {
//     case "ADD_TODO":
//       // returns the todo object
//       return {
//         id: Date.now(),
//         name: action.todo.name,
//         completed:
//           typeof action.todo.completed === "undefined"
//             ? false
//             : action.todo.completed,
//         isTodoRunning:
//           typeof action.todo.isTodoRunning === "undefined"
//             ? false
//             : action.todo.isTodoRunning,
//         plannedMinutes:
//           typeof action.todo.plannedMinutes === "undefined"
//             ? null
//             : action.todo.plannedMinutes,
//         timeLeft:
//           typeof action.todo.plannedMinutes === "undefined"
//             ? null
//             : action.todo.plannedMinutes,
//         creationTime: new Date(),
//         startTime:
//           typeof action.todo.startTime === "undefined"
//             ? null
//             : action.todo.startTime,
//         completionTime:
//           typeof action.todo.completionTime === "undefined"
//             ? null
//             : action.todo.completionTime,
//         todoType:
//           typeof action.todo.todoType === "undefined"
//             ? null
//             : action.todo.todoType,
//       }
//     case "UPDATE_TODO":
//       return {
//         id: action.updatedTodo.id,
//         name: action.updatedTodo.name,
//         completed:
//           typeof action.updatedTodo.completed === "undefined"
//             ? false
//             : action.updatedTodo.completed,
//         isTodoRunning:
//           typeof action.updatedTodo.isTodoRunning === "undefined"
//             ? false
//             : action.updatedTodo.isTodoRunning,
//         plannedMinutes:
//           typeof action.updatedTodo.plannedMinutes === "undefined"
//             ? null
//             : action.updatedTodo.plannedMinutes,
//         timeLeft:
//           typeof action.updatedTodo.timeLeft === "undefined"
//             ? null
//             : action.updatedTodo.timeLeft,
//         creationTime:
//           typeof action.updatedTodo.creationTime === "undefined"
//             ? null
//             : action.updatedTodo.creationTime,
//         startTime:
//           typeof action.updatedTodo.startTime === "undefined"
//             ? null
//             : action.updatedTodo.startTime,
//         completionTime:
//           typeof action.updatedTodo.completionTime === "undefined"
//             ? null
//             : action.updatedTodo.completionTime,
//         todoType:
//           typeof action.updatedTodo.todoType === "undefined"
//             ? null
//             : action.updatedTodo.todoType,
//       }
//     case "TOGGLE_TODO":
//       if (state.id !== action.id) {
//         return state
//       }

//       return {
//         ...state,
//         completed: !state.completed,
//       }
//     default:
//       return state
//   }
// }

export default todos
